import * as prismic from '@prismicio/client'

export const client = prismic.createClient(process.env.REACT_APP_PRISMIC_API_URL)